import { Card } from "../../../components/ui/card";
import { formatCOP } from "../../../lib/api";

export const MarketplaceTab = ({ summary }) => (
  <div className="grid lg:grid-cols-3 gap-4">
    <Card className="lg:col-span-2 bg-white border-cm-border shadow-none p-6" data-testid="marketplace-breakdown">
      <h3 className="font-serif text-lg mb-4">Marketplace vs. Presencial</h3>
      <div className="space-y-4">
        {["portal", "presencial"].map((key) => {
          const row = summary.breakdown[key];
          const pct = summary.breakdown.all.total ? (row.total / summary.breakdown.all.total) * 100 : 0;
          return (
            <div key={key}>
              <div className="flex justify-between text-sm mb-1.5">
                <span className="font-medium capitalize">{key === "portal" ? "Portal B2B" : "Vendedores presenciales"}</span>
                <span className="font-mono text-cm-ink">{formatCOP(row.total)} <span className="text-cm-ink-soft">· {row.count} pedidos</span></span>
              </div>
              <div className="h-3 bg-cm-cream-alt rounded overflow-hidden">
                <div
                  className={`h-full ${key === "portal" ? "bg-cm-red" : "bg-cm-yellow"}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <div className="text-xs text-cm-ink-soft mt-1">{pct.toFixed(1)}% del total</div>
            </div>
          );
        })}
      </div>
    </Card>
    <Card className="bg-cm-ink text-cm-cream border-0 shadow-none p-6" data-testid="marketplace-totals">
      <h3 className="font-serif text-lg mb-4 text-cm-yellow">Resumen</h3>
      <dl className="space-y-3 text-sm">
        <div className="flex justify-between"><dt className="text-cm-cream/70">Ventas totales</dt><dd className="font-mono">{formatCOP(summary.breakdown.all.total)}</dd></div>
        <div className="flex justify-between"><dt className="text-cm-cream/70">Pedidos totales</dt><dd className="font-mono">{summary.breakdown.all.count}</dd></div>
        <div className="border-t border-cm-cream/10 pt-3 mt-3" />
        <div className="flex justify-between"><dt className="text-cm-cream/70">Portal B2B</dt><dd className="font-mono text-cm-yellow">{formatCOP(summary.breakdown.portal.total)}</dd></div>
        <div className="flex justify-between"><dt className="text-cm-cream/70">Presencial</dt><dd className="font-mono">{formatCOP(summary.breakdown.presencial.total)}</dd></div>
      </dl>
    </Card>
  </div>
);
